// Config adapter: the single registry of feature-flag keys the assistant reads via
// `useConfigService`. Callers reference FLAGS.* instead of magic strings, so every
// flag the app depends on is discoverable in one place. This registry grows as
// remaining call sites migrate onto it.
export const FLAGS = {
  // Per-surface render gate (App).
  assistantDtEnabled: 'magic-apron-assistant-dt-enabled',
  assistantMwEnabled: 'magic-apron-assistant-mw-enabled',
  assistantAppEnabled: 'magic-apron-assistant-app-enabled',
  assistantB2bEnabled: 'magic-apron-assistant-b2b-enabled',

  // CONTENT-TREE SWITCH (App). Opts INTO the consolidated in-repo tree; unset, unresolved
  // or false renders the legacy tree (src/legacy/), which is the default. Deleted along with
  // src/legacy/ when that tree is retired — see src/legacy/README.md.
  assistantUnifiedEnabled: 'isLiveChatUnificationEnabled',

  // Config-driven page exclusion (App), from MAG4-815 on master. When the rules flag is
  // off, the legacy allow-list gate (`getIsLegacyCompatiblePage`) applies instead.
  exclusionRulesEnabled: 'magic-apron-assistant-enable-exclusion-rules',
  excludedPages: 'magic-apron-assistant-excluded-pages',

  // OPS TOGGLE / KILL SWITCH for the liveAgent block, read in journeys/useResolvedJourney —
  // the one place journey membership is decided, so a block's presence is traceable from the
  // manifest that declares it down to the orchestrator that freezes it. Lets an operator shed
  // the Sprinklr dependency without a deploy. An EXPLICIT false revokes the block; unset
  // leaves the journey's declaration alone.
  liveAgentEnabled: 'magic-apron-assistant-live-agent-enabled',

  // Dynamic initial suggested questions (useMessageHistory).
  dynamicIsqMasterEnabled: 'magic-apron-initial-suggested-questions-enabled',
  dynamicIsqDtEnabled: 'magic-apron-dynamic-isq-dt-enabled',
  dynamicIsqMwEnabled: 'magic-apron-dynamic-isq-mw-enabled',
  dynamicIsqAppEnabled: 'magic-apron-dynamic-isq-app-enabled',
  dynamicIsqB2bEnabled: 'magic-apron-dynamic-isq-b2b-enabled',
};
